// data/companies.js
export const companies = [
  {
    id: 1,
    name: "DESIGN 한시십분",
    address: "경북 구미시 봉곡로24길 33-11,",
    phone: "010-3913-6196",
    email: "0110moment@gmail.com",
    businessNumber: "308-**-67275"
  },
  {
    id: 2,
    name: "디지털웍스",
    address: "서울특별시 서초구 서초대로 456",
    phone: "02-9876-5432",
    email: "contact@digitalworks.co.kr",
    businessNumber: "098-76-54321"
  },
  {
    id: 3,
    name: "이노베이션 코리아",
    address: "경기도 성남시 분당구 판교로 789",
    phone: "031-1111-2222",
    email: "hello@innovation.kr",
    businessNumber: "111-22-33444"
  }
];

// 기본 회사 정보 (첫 번째 회사를 기본으로 사용)
export const getDefaultCompany = () => {
  return companies[0];
};

// 회사 정보 업데이트 함수 (실제로는 API 호출로 대체)
export const updateCompany = (companyData) => {
  // 실제 구현에서는 서버에 저장
  console.log('Company updated:', companyData);
  return companyData;
};